import { render, staticRenderFns } from "./ExtensionBanner.vue?vue&type=template&id=79ac1388&"
import script from "./ExtensionBanner.vue?vue&type=script&lang=ts&"
export * from "./ExtensionBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports